// Centralized character length limits for UI elements/components

export type NestedLimits = {
    [key: string]: number | NestedLimits;
};

export const LENGTH_LIMITS: NestedLimits = {
    C015QuoteCarousel: {
        headline: 80,
    },
    C020TeaserCard: {
        description: 151,
        header: 58,
        roofline: 40,
    },
    C060OverlayTeaser: {
        headline: 80,
        details: 300,
    },
    C061OverlayContact: {
        title: 80,
        subtitle: 120,
    },
    C062OverlayForm: {
        headlinePrimary: 80,
        headlineSecondary: 60,
    },
    C078ViewTypeImageText: {
        description: 400,
    },
    C082CenteredStageTeaser: {
        title: 150,
    },
    CCOAiGeneratedImageLabel: {
        text: 60,
    },
};

/**
 * Resolve a dot-notated key like "SOSTeaser.teaserTitle" against LENGTH_LIMITS.
 *
 * Usage pattern with optional settings override:
 *   getLengthLimit('C015QuoteCarousel.headline', settingsValue)
 * If a numeric settingsValue is provided, it is returned. Otherwise, the default
 * from LENGTH_LIMITS is used. If the key is missing, Infinity is returned.
 *
 * @param key dot-notated key path
 * @param settingsOverride optional numeric limit coming from site/settings
 */
export function getLengthLimit(key: string, settingsOverride?: number): number {
    if (typeof settingsOverride === 'number' && !Number.isNaN(settingsOverride)) {
        return settingsOverride;
    }
    const parts = key.split(".").filter(Boolean);
    let node: any = LENGTH_LIMITS;
    for (const p of parts) {
        if (node && typeof node === "object" && p in node) {
            node = (node as any)[p];
        } else {
            return Number.POSITIVE_INFINITY;
        }
    }
    if (typeof node === "number") return node as number;
    return Number.POSITIVE_INFINITY;
}
